import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { createTwilioCustomerProfile } from 'api/admin/businesses/twilioIntegration';
import { CreateTwilioCustomerProfileRequestPayload } from 'types/twilio/twilioCustomerProfile';

interface useCreateTwilioCustomerProfilePayload {
  successCallback?: () => void;
}

export const useCreateTwilioCustomerProfile = ({
  successCallback,
}: useCreateTwilioCustomerProfilePayload) => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    CreateTwilioCustomerProfileRequestPayload
  >({
    mutationFn: async ({ businessId, data }) => {
      return createTwilioCustomerProfile({ businessId, data });
    },
    onSuccess: async () => {
      successCallback?.();

      toaster('Customer profile has been created', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while creating customer profile', {
        icon: '❌',
      });

      /** We should try to call success callback because customer profile could be created even if we got not validation errors */
      if (error?.response?.status && ![422, 400].includes(error.response.status)) {
        successCallback?.();
      }

      return error;
    },
  });
};
